<template>
  <v-app>
    <div>
      <v-toolbar>
        <v-container fill-height fluid>
          <div class="d-flex align-center">
            <v-img
                alt="Vuetify Name"
                class="shrink mt-1 hidden-sm-and-down"
                contain
                min-width="100"
                :src="require('./assets/revel-x-como.svg')"
                width="200"
            />
          </div>
          <v-spacer></v-spacer>
          <v-layout justify-end>
            <v-flex xs3>
              <v-text-field
                  :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                  @click:append="showPassword = !showPassword"
                  :type="showPassword ? 'text' : 'password'"
                  name="input-10-2"
                  label="API Key"
                  v-model="apiKey"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-btn v-on:click="newBusiness()">Go!</v-btn>
      </v-toolbar>
    </div>
    <v-main>
      <v-container fluid style="max-width: 1280px">
<!--        <v-row>-->
<!--          <v-col lg="12" md="12" xs="12">-->
<!--            <CreateBusinessForm v-on:new-business="newBusiness"/>-->
<!--          </v-col>-->
<!--        </v-row>-->
        <v-row>
          <v-col lg="12" md="12" xs="12">
            <Businesses ref="businessComponent"/>
          </v-col>

        </v-row>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Businesses from './components/Businesses';
//import CreateBusinessForm from "./components/CreateBusinessForm";

export default {
  name: 'App',
  components: {
    Businesses,
    //CreateBusinessForm
  },
  watch: {
    apiKey(newApiKey) {
      localStorage.setItem("apiKey", newApiKey)
    }
  },
  methods: {
    newBusiness() {
      this.$refs.businessComponent.refresh()
    }
  },

  data: () => ({
    showPassword: false,
    apiKey: localStorage.getItem("apiKey"),
  }),
};
</script>
